import { paginationFragment } from './fragments/pagination';

const fragment = `
  id
  externalId
  name
  floor
  price
  availability
  floorLocation
  view
  imageUrl
  defaultImageUrl
  tourUrl
  openTourUrlInOverlayWindow
  uTourUrl
  hashId
  buildingModel {
    id
    name
    imageUrl
    bedrooms
    bathrooms
    size
    project {
      id
      name
      address
    }
  }
  options {
    price
    optionType {
      name
    }
  }
  designedObject
  buildingFloor {
    id
  }  
  lastModifiedLog @include(if: $withLastModification) {
    id
    initialValue
    finalValue
    maker {
      id
      name
      role
    }
  }
  creator {
    id
    name
    role
  }
  status
  createdAt
  updatedAt
  archivedAt
  isFeatured
  discountedPrice
`;

export const listUnitsQuery = `
  query ListUnits(
    $filter: UnitFilterInput
    $sort: SortInput
    $page: Int
    $pageSize: Int
    $withLastModification: Boolean! = false
  ) {
    result: listAndPaginateUnits(filter: $filter, sort: $sort, page: $page, pageSize: $pageSize) {
      items {
        ${fragment}
      }
      pagination {
        ${paginationFragment}
      }
    }
  }
`;

export const getUnitQuery = `
  query GetUnit(
    $id: Int!
    $withLastModification: Boolean! = true
  ) {
    item: getUnit(id: $id) {
      ${fragment}
    }
  }
`;

export const createUnitQuery = `
  mutation CreateUnit(
    $input: CreateUnitInput!,
    $image: Upload
    $withLastModification: Boolean! = true
  ) {
    item: createUnit(input: $input, image: $image) {
      ${fragment}
    }
  }
`;

export const updateUnitQuery = `
  mutation UpdateUnit(
    $input: UpdateUnitInput!,
    $image: Upload
    $withLastModification: Boolean! = true
  ) {
    item: updateUnit(input: $input, image: $image) {
      ${fragment}
    }
  }
`;

export const deleteUnitQuery = `
  mutation DeleteUnit(
    $id: Int!
    $withLastModification: Boolean! = true
  ) {
    item: deleteUnit(id: $id) {
      ${fragment}
    }
  }
`;

export const exportUnitsMutation = `
  mutation ExportUnits(
    $filter: UnitFilterInput
  ) {
    version: exportUnits(filter: $filter)
  }
`;

export const bulkUpdateUnitsMutation = `
  mutation BulkUpdateUnits(
    $input: BulkUpdateUnitInput!
    $filter: UnitFilterInput
    $bulkSelection: BulkSelectionInput
  ) {
    updated: bulkUpdateUnits(input: $input, filter: $filter, bulkSelection: $bulkSelection)
  }
`;

export const setUnitArchiveStateMutation = `
  mutation SetUnitArchiveState(
    $id: Int!
    $archived: Boolean!
  ) {
    updated: setUnitArchiveState(id: $id, archived: $archived)
  }
`;
